(function () {
  "use strict";

  angular
    .module("app")
    .controller("pcmtidloginController", pcmtidloginController);
  pcmtidloginController.inject = ["$rootScope", "$scope", "pcmtidLoginService","routeParams","ALKLogin","alkAuthenticationService","UserProvider","$location","alkModalService"
  ];
  function pcmtidloginController($rootScope, $scope,pcmtidLoginService,$routeParams,ALKLogin,alkAuthenticationService,UserProvider,$location,alkModalService) {

    var vm = this;
    vm.authCode = $routeParams.code;
    vm.state = $routeParams.state;
    vm.formTab = "login";
    vm.isProcessing = false;
    vm.showLegacySignIn = {};
    vm.showLegacySignIn.show  = false;
    vm.clientId = pcmtidLoginService.getClientId();
    vm.tidApplicationName = pcmtidLoginService.getTidApplicationName();
    vm.trimbleCloudUrl = pcmtidLoginService.getTrimbleCloudUrl();
    var redirectUrl = `${pcmtidLoginService.baseUrl() }/tid/redirect`;

    vm.config = {migrationDate:"2022-09-07",
      countdownComponent: {
        useDarkText: false
      },
      migrateComponent: {
        useDarkSignInTidText:false,
        useOutlineSignInTidButton:false
      },
      eventHandler:function(event) {console.log(event);
        var type = event.type;
        vm.username = event.username;
        vm.password = event.password;
        vm.account = event.account;
        $scope.userNotExistError = false;

        if (type === "SIGN_IN_CONFIRM_CANCEL") {
          vm.tidcontrol.stopSignInWaiting();
        }

        if (type === "SIGN_IN_USERNAME") {
          pcmtidLoginService.checkTidEmail(vm.username).then((data) => {
            if (data.exists) {
              if (data.migrated) {
                var url = pcmtidLoginService.goToTidSignin(vm.username,redirectUrl);
                window.location.href = url;
              } else {
                vm.tidcontrol.showSignInConfirm();
              }} else {
              $scope.userNotExistError = true;
              vm.tidcontrol.stopSignInWaiting();
            }

          }, (error) => {
            console.log("migrate error");
          });

        }
        if (type === "SIGN_IN_PASSWORD") {

          var login = new ALKLogin(vm.username, vm.password, vm.account);
          vm.login(login);
        }
        if (type === "SIGN_IN_ACCOUNT") {
          if (vm.authCode) {
            vm.tidloginAccount(vm.authCode,vm.account);
          } else {
            login = new ALKLogin(vm.username, vm.password, vm.account);
            vm.login(login);
          }


        }

        if (type === "SIGN_IN_TID") {
          var url =  pcmtidLoginService.goToTidSignin(vm.username,redirectUrl);
          window.location.href = url;
        }
        if (type === "CREATE_TID") {
          var createUrl = pcmtidLoginService.goToTidSignup(vm.username,redirectUrl);
          window.location.href = createUrl;
        }

      }};
    vm.loadTrimbleID = function() {
      tmxtidmodule.init(vm.config).destroy();
      vm.tidcontrol = tmxtidmodule.init(vm.config);
    }

    $rootScope.$on("forgotPassword",(msg) => {
      vm.formTab = "forgot";
    });


    vm.loadTrimbleID();

    vm.login = function(login) {
      alkAuthenticationService.login(login).then(() => {

        $scope.loginSuccess();

        $scope.checkAuth = true;
      }, (error) => {

        var failedLogin = vm.authenticateErrorHandler(error);

        if (failedLogin) {
          vm.tidcontrol.stopSignInWaiting();
          // $scope.accounts = [];
          // delete $scope.userInfo.account;
        }
        $scope.isProcessing = false;
      });
    }
    $scope.loginSuccess = function () {
      const user = UserProvider.getUser();
      try {
        trackJs.configure({
          userId: `${user.userName} (#${user.userId}), Account ${user.account} (#${user.accountId})`
        });
      } catch (err) {
        console.log("trackJs configure error:", err);
      }

      var gotoPage = $location.search().path || "/app";
      var message;

      // if netSuite is down, temporarily allow user to login and disable billing related features.
      if (!user.netSuiteOnline) {
        $location.url(gotoPage);
      }
      else if (user.hasBillingIssue) {
        message = user.isAdmin() ?
          "There was an error to the credit card on file.  Go to Account Settings and update your card information to continue." :
          "There was an error to the credit card on file.  Please have your company’s administrator go to Account Settings to update your card information.";

        alkModalService.show({
          size: "sm"
        }, {
          headerText: "Billing Issue",
          bodyText: message,
          okOnly: true,
          actionButtonText: user.isAdmin() ? "Update Now" : "OK"
        }).then(() => {
          $location.url("/account");
        });

      }
      else if (typeof user.creditExpiresSoon === "function" && user.creditExpiresSoon() && user.isMonthlyPaidCustomer && !user.isInvoiced) {
        message = user.isAdmin() ?
          `The credit card linked to your account is set to expire on ${  user.getCreditExpiresDate().format("MM/DD/YYYY")  }.  To avoid any disruption in service, please update your card information now.` :
          `The credit card linked to your account is set to expire on ${  user.getCreditExpiresDate().format("MM/DD/YYYY")  }.  To avoid any disruption in service, please have your company’s administrator update the card information.`;

        alkModalService.show({
          size: "sm"
        }, {
          headerText: "Billing Warning",
          bodyText: message,
          okOnly: !user.isAdmin() ||  (user.isMonthlyPaidCustomer && user.checkCreditExpiration()) ,
          closeButtonText: "Later",
          actionButtonText: user.isAdmin() ? "Update Now" : "OK"
        }).then(() => {
          if (user.isAdmin()) {
            $location.url("/account");
          } else {
            $location.url(gotoPage);
          }
        }).catch(() => {
          $location.url(gotoPage);
        });

      }  else {
        $location.url(gotoPage);
      }
    };

    // eslint-disable-next-line complexity
    vm.authenticateErrorHandler = function(error) {
      var failedLogin = true;
      // if username/password was not correct.
      if (error.status !== null && error.status === "FailedToLogin") {
        $scope.showPasswordIncorrect = true;
        vm.tidcontrol.showSignInPassword();
      //  FIXME:
      //  handle this
      } else if (error.status === "FailedToLoginAccountDisabled" || error.status === "AccountDisabled") {
        $scope.showAccountDisabled = true;
      }
      else if (error.status === "FailedToLoginUserDisabled" || error.status === "UserDisabled") {
        $scope.showUserDisabled = true;
      }
      else if (error.status === "FailedToValidateTrimbleIdentityToken") {
        $scope.showValidateTrimbleDisabled = true;

      }
      // if username/password was correct but does not belong to any account.
      else if (error.status !== null && error.status === "FailedToLoginNotAuthorized") {
        $scope.showNoAccountForApplication = true;
      // if username/password was correct but has one or more accounts. Display the accounts and user can selecte one.
      } else if (error.status !== null && error.status === "FailedToLoginDueToMultipleAccounts" && error.accounts.length > 0) {
        $scope.accounts = error.accounts;
        var options = [];
        for (let i = 0;i < $scope.accounts.length;i++) {

          var option =  {value:$scope.accounts[i].accountName,displayName:$scope.accounts[i].accountName};
          console.log(option);
          options.push(option);
        }

        vm.tidcontrol.showSignInAccounts(options);
        // $scope.userInfo.account = $scope.accounts[0].accountName;
        // loginForm.submitted = false;
        failedLogin = false;
        vm.hideErrorMessage();
      } else if (error.status !== null && error.status === "FailedToLoginAccountExpired") {
      // if the account expired, we need to get userInfo and redirect user to account page for upgrade.
      if(typeof(error.userInfo) !== 'undefined'){
        alkAuthenticationService
          .getUserInfo(error.userInfo.authToken, error.userInfo.username, error.userInfo.accountName)
          .then((response) => {
            UserProvider.loadUser(response.user);
            $scope.loginSuccess();
          }, (err) => {
            $scope.showLoginAccountExpired = true;
            console.log("rejected user info", err);
          });
        }else{
          $scope.showAccountDisabled = true;
        }
      } else {
      //Should handle generic errors, i.e. 500
        $scope.showGenericError = true;
        vm.tidcontrol.showSignInUsername();

      }
      return failedLogin;
    }

    vm.tidloginAccount = function(authCode,account) {
      pcmtidLoginService.tidlogin(authCode,account,redirectUrl).then(() => {

        $scope.loginSuccess();
        $scope.checkAuth = true;

      }, (error) => {

        var failedLogin = vm.authenticateErrorHandler(error);
        if (failedLogin) {
          vm.tidcontrol.setSignInValues();
          vm.tidcontrol.stopSignInWaiting();
          vm.tidcontrol.showSignInUsername();
        // $scope.accounts = [];
        // delete $scope.userInfo.account;
        } else {
          $scope.showAccountDisabled = false;
          $scope.showUserDisabled = false;
          $scope.showPasswordIncorrect = false;
          $scope.showNoAccountForApplication = false;
          $scope.showGenericError = false;
        }
        $scope.isProcessing = false;
      });
    }
    if (vm.authCode) {
      if (vm.tidcontrol) {

        vm.tidcontrol.setSignInValues(vm.state,null,null);
        vm.tidcontrol.startSignInWaiting();
        vm.tidloginAccount(vm.authCode,null,redirectUrl);
      } else {
        vm.loadTrimbleID();
        vm.tidloginAccount(vm.authCode,null,redirectUrl);
      }
    }
    vm.hideErrorMessage = function() {
      $scope.showAccountDisabled = false;
      $scope.showUserDisabled = false;
      $scope.showPasswordIncorrect = false;
      $scope.showNoAccountForApplication = false;
      $scope.showGenericError = false;
      // $scope.$apply();
    }
  }


})();



// WEBPACK FOOTER //
// ./app/account/pcmtidlogin.controller.js